import siteConfig from "./siteConfig";

const apparelSizes = ["XS", "S", "M", "L", "XL", "2XL"];

const catalog = [
  {
    id: 1,
    name: "RIDGELINE 3L SHELL M",
    category: "Jackets",
    audience: "Men",
    activity: "Trekking",
    price: 180,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Deep Navy", "Moss Green"],
    material: "100% recycled polyamide, 3-layer membrane",
    description:
      "A durable three-layer shell for exposed ridges, persistent rain and long days under a pack.",
    features: [
      "20,000 mm waterproof rating",
      "Helmet-compatible adjustable hood",
      "Two-way underarm ventilation",
      "Pack-friendly raised hand pockets",
    ],
    attributes: { Waterproof: "20,000 mm", Breathability: "15,000 g/m²/24h", Fit: "Regular", Weight: "510 g" },
    tags: ["waterproof", "windproof", "recycled", "sale"],
    rating: 4.8,
    reviews: 184,
    badge: "-20%",
    stock: 18,
  },
  {
    id: 2,
    name: "TORVALE LIGHT SHELL W",
    category: "Jackets",
    audience: "Women",
    activity: "Hiking",
    price: 165,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Burnt Orange", "Midnight Blue"],
    material: "Recycled ripstop shell with 2.5-layer membrane",
    description:
      "A light, packable rain shell balancing all-day comfort with reliable trail protection.",
    features: ["15,000 mm waterproof rating", "Stows into its own pocket", "Articulated sleeves", "PFC-free water-repellent finish"],
    attributes: { Waterproof: "15,000 mm", Breathability: "12,000 g/m²/24h", Fit: "Athletic", Weight: "295 g" },
    tags: ["waterproof", "packable", "recycled"],
    rating: 4.7,
    reviews: 132,
    badge: "New",
    stock: 24,
  },
  {
    id: 3,
    name: "FOREST PASS 3IN1 JKT M",
    category: "Jackets",
    audience: "Men",
    activity: "Everyday",
    price: 180,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Forest Green", "Black"],
    material: "Recycled waterproof shell with removable insulated liner",
    description:
      "One adaptable system for wet autumn walks, cold commutes and shifting winter conditions.",
    features: ["Wear as shell, liner or combined", "Waterproof taped construction", "Detachable adjustable hood", "Seven secure pockets"],
    attributes: { Waterproof: "10,000 mm", Warmth: "High", Fit: "Regular", Weight: "980 g" },
    tags: ["3-in-1", "waterproof", "insulated", "sale"],
    rating: 4.9,
    reviews: 219,
    badge: "-20%",
    stock: 15,
  },
  {
    id: 4,
    name: "ALPENGLOW DOWN JKT W",
    category: "Jackets",
    audience: "Women",
    activity: "Trekking",
    price: 180,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Dark Berry", "Glacier Blue"],
    material: "Recycled shell with 700-fill responsibly sourced down",
    description:
      "Warmth without bulk for frosty trail starts, windy summits and compact layering.",
    features: ["700-fill down insulation", "Wind-resistant woven baffles", "Adjustable insulated hood", "Packs into internal pocket"],
    attributes: { Insulation: "700 fill", Warmth: "High", Fit: "Regular", Weight: "420 g" },
    tags: ["down", "warm", "packable", "recycled"],
    rating: 4.8,
    reviews: 97,
    badge: "Bestseller",
    stock: 12,
  },
  {
    id: 5,
    name: "CRAG MOVE SOFTSHELL M",
    category: "Jackets",
    audience: "Men",
    activity: "Hiking",
    price: 145,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Slate Grey", "Night Blue"],
    material: "Double-weave stretch softshell with brushed interior",
    description:
      "A breathable, wind-resistant softshell that moves easily on steep and technical ground.",
    features: ["Four-way stretch", "Wind-resistant face fabric", "Harness-compatible pockets", "Adjustable hem"],
    attributes: { Windproof: "High", Stretch: "4-way", Fit: "Athletic", Weight: "465 g" },
    tags: ["softshell", "stretch", "wind-resistant"],
    rating: 4.6,
    reviews: 88,
    badge: "",
    stock: 31,
  },
  {
    id: 6,
    name: "SKY TRAIL WIND JKT W",
    category: "Jackets",
    audience: "Women",
    activity: "Trail Running",
    price: 105,
    compareAtPrice: 130,
    size: apparelSizes,
    colors: ["Pale Sage", "Coral"],
    material: "Ultralight recycled polyamide ripstop",
    description:
      "An airy wind layer that disappears into a waist pack and is ready when the weather turns.",
    features: ["Highly wind resistant", "Laser-cut back ventilation", "Packs into chest pocket", "Reflective trail details"],
    attributes: { Windproof: "High", Packable: "Yes", Fit: "Active", Weight: "155 g" },
    tags: ["running", "packable", "wind-resistant", "sale"],
    rating: 4.7,
    reviews: 61,
    badge: "-20%",
    stock: 20,
  },
  {
    id: 7,
    name: "SUMMIT GRID FLEECE M",
    category: "Fleece & Midlayers",
    audience: "Men",
    activity: "Hiking",
    price: 95,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Cobalt", "Dark Moss"],
    material: "Recycled polyester grid fleece",
    description:
      "A fast-wicking technical midlayer with mapped warmth and low bulk beneath a shell.",
    features: ["Breathable grid structure", "Smooth outer face", "Two zipped hand pockets", "Flatlock seams"],
    attributes: { Warmth: "Medium", Breathability: "High", Fit: "Regular", Weight: "360 g" },
    tags: ["fleece", "breathable", "recycled"],
    rating: 4.8,
    reviews: 143,
    badge: "Bestseller",
    stock: 40,
  },
  {
    id: 8,
    name: "CEDAR HIGHLOFT JKT W",
    category: "Fleece & Midlayers",
    audience: "Women",
    activity: "Everyday",
    price: 110,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Natural Cream", "Rosewood"],
    material: "Recycled high-pile fleece",
    description:
      "Soft high-loft fleece brings dependable warmth to cool campsites and relaxed winter days.",
    features: ["Dense high-pile insulation", "Soft stand collar", "Reinforced pocket openings", "Adjustable hem"],
    attributes: { Warmth: "High", Breathability: "Medium", Fit: "Relaxed", Weight: "540 g" },
    tags: ["fleece", "warm", "recycled"],
    rating: 4.9,
    reviews: 176,
    badge: "Bestseller",
    stock: 22,
  },
  {
    id: 9,
    name: "MERINO RIDGE HALF ZIP M",
    category: "Fleece & Midlayers",
    audience: "Men",
    activity: "Trekking",
    price: 120,
    compareAtPrice: 150,
    size: apparelSizes,
    colors: ["Rust", "Graphite"],
    material: "Responsible merino wool and recycled polyester blend",
    description:
      "Naturally odour-resistant merino comfort tuned for long-distance layers and cool evenings.",
    features: ["Temperature regulating", "Odour resistant", "Low-profile half zip", "Drop-tail coverage"],
    attributes: { Warmth: "Medium", Breathability: "High", Fit: "Regular", Weight: "285 g" },
    tags: ["merino", "breathable", "sale"],
    rating: 4.6,
    reviews: 74,
    badge: "-20%",
    stock: 17,
  },
  {
    id: 10,
    name: "TRAIL FLOW HOODY W",
    category: "Fleece & Midlayers",
    audience: "Women",
    activity: "Hiking",
    price: 85,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Trail Teal", "Black"],
    material: "Stretch recycled polyester jersey",
    description:
      "A light hooded layer that manages moisture on uphill pushes and cool trail breaks.",
    features: ["Quick-drying stretch knit", "Low-profile fitted hood", "Thumb-loop cuffs", "Zipped side pocket"],
    attributes: { Warmth: "Light", Breathability: "High", Fit: "Active", Weight: "265 g" },
    tags: ["hoodie", "quick-dry", "stretch"],
    rating: 4.7,
    reviews: 69,
    badge: "New",
    stock: 34,
  },
  {
    id: 11,
    name: "AIR PATH TECH T M",
    category: "Tops",
    audience: "Men",
    activity: "Trail Running",
    price: 45,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Clay Red", "Graphite"],
    material: "Recycled moisture-wicking jersey",
    description:
      "A cool, light technical tee designed to dry fast through warm miles and hard efforts.",
    features: ["Rapid moisture transfer", "Odour-control finish", "Chafe-reducing seams", "Reflective rear detail"],
    attributes: { Breathability: "Very high", Drying: "Fast", Fit: "Active", Weight: "145 g" },
    tags: ["running", "quick-dry", "recycled"],
    rating: 4.5,
    reviews: 51,
    badge: "",
    stock: 55,
  },
  {
    id: 12,
    name: "SUN RIDGE LS W",
    category: "Tops",
    audience: "Women",
    activity: "Travel",
    price: 58,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Light Sand", "Mist Blue"],
    material: "Lightweight recycled stretch jersey",
    description:
      "An easy long-sleeve layer with cooling comfort and high sun protection for open trails.",
    features: ["UPF 50+ protection", "Cooling touch fabric", "Quick drying", "Extended cuff coverage"],
    attributes: { SunProtection: "UPF 50+", Breathability: "High", Fit: "Regular", Weight: "175 g" },
    tags: ["sun protection", "travel", "quick-dry"],
    rating: 4.7,
    reviews: 93,
    badge: "",
    stock: 38,
  },
  {
    id: 13,
    name: "CAMP RIDGE OVERSHIRT M",
    category: "Tops",
    audience: "Men",
    activity: "Everyday",
    price: 90,
    compareAtPrice: 115,
    size: apparelSizes,
    colors: ["Blue Grey", "Earth Brown"],
    material: "Recycled brushed stretch twill",
    description:
      "A hard-wearing overshirt with enough warmth for evening camps and everyday layering.",
    features: ["Soft brushed interior", "Mechanical stretch", "Two secure chest pockets", "Reinforced elbows"],
    attributes: { Warmth: "Medium", Stretch: "2-way", Fit: "Relaxed", Weight: "430 g" },
    tags: ["overshirt", "durable", "sale"],
    rating: 4.6,
    reviews: 48,
    badge: "-20%",
    stock: 23,
  },
  {
    id: 14,
    name: "BASE CAMP THERMAL W",
    category: "Tops",
    audience: "Women",
    activity: "Trekking",
    price: 68,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Dark Plum", "Charcoal"],
    material: "Merino-blend thermal jersey",
    description:
      "A next-to-skin thermal that holds warmth, moves freely and stays fresh over multi-day trips.",
    features: ["Merino-blend odour control", "Body-mapped knit zones", "Flat seams", "Long back coverage"],
    attributes: { Warmth: "Medium", Breathability: "High", Fit: "Close", Weight: "220 g" },
    tags: ["baselayer", "merino", "warm"],
    rating: 4.8,
    reviews: 86,
    badge: "",
    stock: 36,
  },
  {
    id: 15,
    name: "GRANITE TREK PANT M",
    category: "Trousers",
    audience: "Men",
    activity: "Trekking",
    price: 115,
    compareAtPrice: null,
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Charcoal", "Dark Khaki"],
    material: "Abrasion-resistant recycled stretch weave",
    description:
      "Technical trekking trousers shaped for high steps, rough rock and long days with a pack.",
    features: ["Articulated knees", "Four-way stretch", "Four zipped pockets", "Boot-adjustable hems"],
    attributes: { Stretch: "4-way", Durability: "High", Fit: "Regular", Weight: "455 g" },
    tags: ["trekking", "stretch", "durable"],
    rating: 4.8,
    reviews: 157,
    badge: "Bestseller",
    stock: 29,
  },
  {
    id: 16,
    name: "MOOR FLEX PANT W",
    category: "Trousers",
    audience: "Women",
    activity: "Hiking",
    price: 100,
    compareAtPrice: 125,
    size: ["6", "8", "10", "12", "14", "16"],
    colors: ["Olive", "Midnight"],
    material: "Weather-resistant softshell stretch fabric",
    description:
      "Weather-resistant hiking trousers with an ergonomic cut and clean everyday silhouette.",
    features: ["Four-way stretch", "Water-repellent finish", "Shaped waistband", "Three zipped pockets"],
    attributes: { Windproof: "Medium", Stretch: "4-way", Fit: "Slim", Weight: "395 g" },
    tags: ["hiking", "softshell", "sale"],
    rating: 4.7,
    reviews: 119,
    badge: "-20%",
    stock: 27,
  },
  {
    id: 17,
    name: "SWITCHBACK ZIP-OFF M",
    category: "Trousers",
    audience: "Men",
    activity: "Travel",
    price: 92,
    compareAtPrice: null,
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Trail Khaki", "Graphite"],
    material: "Light recycled stretch weave",
    description:
      "Convertible walking trousers that switch quickly to shorts as the temperature climbs.",
    features: ["Colour-coded zip-off legs", "Fast-drying fabric", "Integrated belt", "Five travel pockets"],
    attributes: { Convertible: "Yes", Drying: "Fast", Fit: "Regular", Weight: "385 g" },
    tags: ["convertible", "travel", "quick-dry"],
    rating: 4.5,
    reviews: 64,
    badge: "",
    stock: 21,
  },
  {
    id: 18,
    name: "FELL RUN SHORT W",
    category: "Trousers",
    audience: "Women",
    activity: "Trail Running",
    price: 55,
    compareAtPrice: null,
    size: apparelSizes,
    colors: ["Dark Teal", "Black"],
    material: "Ultralight stretch shell with soft liner",
    description:
      "Light trail shorts with a supportive inner brief and stable storage for moving fast.",
    features: ["Quick-dry outer", "Breathable inner brief", "Secure rear phone pocket", "Bonded low-bulk hems"],
    attributes: { Stretch: "4-way", Drying: "Very fast", Fit: "Active", Weight: "155 g" },
    tags: ["running", "quick-dry", "stretch"],
    rating: 4.6,
    reviews: 47,
    badge: "New",
    stock: 32,
  },
  {
    id: 19,
    name: "TOR PATH MID BOOT",
    category: "Footwear",
    audience: "Unisex",
    activity: "Trekking",
    price: 175,
    compareAtPrice: null,
    size: ["EU 37", "EU 38", "EU 39", "EU 40", "EU 41", "EU 42", "EU 43", "EU 44"],
    colors: ["Dark Brown", "Slate"],
    material: "Certified leather and abrasion-resistant textile",
    description:
      "A supportive waterproof mid boot with confident grip for rocky routes and loaded trekking.",
    features: ["Waterproof breathable lining", "Protective toe and heel rand", "Cushioned trekking midsole", "Deep multi-directional lugs"],
    attributes: { Waterproof: "Yes", Support: "High", Fit: "Standard", Weight: "1,080 g/pair" },
    tags: ["boots", "waterproof", "trekking"],
    rating: 4.9,
    reviews: 228,
    badge: "Bestseller",
    stock: 26,
  },
  {
    id: 20,
    name: "CREEK LINE TEX SHOE W",
    category: "Footwear",
    audience: "Women",
    activity: "Hiking",
    price: 135,
    compareAtPrice: 170,
    size: ["EU 36", "EU 37", "EU 38", "EU 39", "EU 40", "EU 41"],
    colors: ["Light Grey / Coral", "Night Blue"],
    material: "Recycled mesh and synthetic reinforcement",
    description:
      "A nimble waterproof trail shoe combining day-hike grip with trainer-like cushioning.",
    features: ["Waterproof breathable membrane", "Rockered hiking sole", "Protective toe cap", "Recycled mesh upper"],
    attributes: { Waterproof: "Yes", Cushioning: "Medium", Fit: "Standard", Weight: "690 g/pair" },
    tags: ["shoes", "waterproof", "sale"],
    rating: 4.7,
    reviews: 104,
    badge: "-20%",
    stock: 19,
  },
  {
    id: 21,
    name: "COAST TRAIL SANDAL M",
    category: "Footwear",
    audience: "Men",
    activity: "Travel",
    price: 78,
    compareAtPrice: null,
    size: ["EU 40", "EU 41", "EU 42", "EU 43", "EU 44", "EU 45", "EU 46"],
    colors: ["Dark Olive", "Black"],
    material: "Quick-dry textile with rubber toe protection",
    description:
      "A closed-toe sandal for warm-weather trails, river crossings and relaxed travel days.",
    features: ["Protective rubber toe", "Drainage-friendly footbed", "Quick-toggle lacing", "High-traction outsole"],
    attributes: { WaterReady: "Yes", Cushioning: "Medium", Fit: "Standard", Weight: "620 g/pair" },
    tags: ["sandals", "travel", "quick-dry"],
    rating: 4.5,
    reviews: 72,
    badge: "",
    stock: 33,
  },
  {
    id: 22,
    name: "TRAVERSE 28 PACK",
    category: "Equipment",
    audience: "Unisex",
    activity: "Hiking",
    price: 125,
    compareAtPrice: null,
    size: ["28 L"],
    colors: ["Moss Green", "Night Blue"],
    material: "Recycled ripstop polyamide",
    description:
      "A balanced 28-litre hiking pack with a ventilated carry system and intuitive trail access.",
    features: ["Ventilated mesh back", "Hydration compatible", "Integrated rain cover", "Dual hip-belt pockets"],
    attributes: { Volume: "28 L", BackLength: "46–54 cm", RainCover: "Included", Weight: "1,080 g" },
    tags: ["backpack", "hiking", "recycled"],
    rating: 4.8,
    reviews: 126,
    badge: "Bestseller",
    stock: 16,
  },
  {
    id: 23,
    name: "DAYBREAK 18 PACK",
    category: "Equipment",
    audience: "Unisex",
    activity: "Everyday",
    price: 82,
    compareAtPrice: 102,
    size: ["18 L"],
    colors: ["Ochre", "Graphite"],
    material: "Recycled wax-touch polyester",
    description:
      "A compact daypack with trail-ready comfort and an organised sleeve for daily essentials.",
    features: ["Padded 15-inch laptop sleeve", "Breathable back panel", "Dual bottle pockets", "Hidden valuables pocket"],
    attributes: { Volume: "18 L", Laptop: "Up to 15 in", WaterResistant: "Yes", Weight: "710 g" },
    tags: ["daypack", "everyday", "sale"],
    rating: 4.6,
    reviews: 83,
    badge: "-20%",
    stock: 28,
  },
  {
    id: 24,
    name: "SHADE PATH HAT",
    category: "Equipment",
    audience: "Unisex",
    activity: "Travel",
    price: 45,
    compareAtPrice: null,
    size: ["S/M", "L/XL"],
    colors: ["Slate Blue", "Khaki"],
    material: "Recycled quick-dry polyamide",
    description:
      "A packable wide-brim trail hat with cooling ventilation and dependable sun coverage.",
    features: ["UPF 50+ protection", "Laser-cut crown vents", "Adjustable chin cord", "Crush-packable brim"],
    attributes: { SunProtection: "UPF 50+", Packable: "Yes", Fit: "Adjustable", Weight: "92 g" },
    tags: ["hat", "sun protection", "travel"],
    rating: 4.6,
    reviews: 59,
    badge: "",
    stock: 46,
  },
  {
    id: 25,
    name: "NORTH LOOP BEANIE",
    category: "Equipment",
    audience: "Unisex",
    activity: "Everyday",
    price: 45,
    compareAtPrice: null,
    size: ["One size"],
    colors: ["Charcoal", "Moss"],
    material: "Recycled wool-blend rib knit",
    description:
      "A soft rib-knit beanie with a warm double cuff for cold trailheads and winter streets.",
    features: ["Warm double-layer knit", "Soft recycled wool blend", "Shape-retaining rib", "One-size stretch fit"],
    attributes: { Warmth: "Medium", Fit: "Stretch", Care: "Hand wash", Weight: "88 g" },
    tags: ["beanie", "warm", "recycled"],
    rating: 4.8,
    reviews: 112,
    badge: "",
    stock: 62,
  },
  {
    id: 26,
    name: "KIDS CLOUD FLEECE",
    category: "Fleece & Midlayers",
    audience: "Kids",
    activity: "Everyday",
    price: 58,
    compareAtPrice: null,
    size: ["104", "116", "128", "140", "152", "164"],
    colors: ["Cobalt", "Berry"],
    material: "Recycled high-pile polyester fleece",
    description:
      "A cosy, easy-care fleece for playground mornings, family camps and cool woodland walks.",
    features: ["Soft high-pile warmth", "Chin-protecting zip guard", "Two zipped pockets", "Reinforced shoulders"],
    attributes: { Warmth: "High", Fit: "Regular", Care: "Machine wash", Weight: "310 g" },
    tags: ["kids", "fleece", "warm", "recycled"],
    rating: 4.9,
    reviews: 91,
    badge: "Bestseller",
    stock: 39,
  },
  {
    id: 27,
    name: "KIDS RAINBURST SHELL",
    category: "Jackets",
    audience: "Kids",
    activity: "Hiking",
    price: 72,
    compareAtPrice: 90,
    size: ["104", "116", "128", "140", "152", "164"],
    colors: ["Sun Yellow", "Lake Blue"],
    material: "Recycled waterproof shell with soft lining",
    description:
      "Bright, dependable rain protection built for puddles, school days and family adventures.",
    features: ["10,000 mm waterproof rating", "Reflective visibility details", "Detachable safety hood", "Grow-with-me cuff adjustment"],
    attributes: { Waterproof: "10,000 mm", Breathability: "6,000 g/m²/24h", Fit: "Regular", Weight: "340 g" },
    tags: ["kids", "waterproof", "sale"],
    rating: 4.8,
    reviews: 137,
    badge: "-20%",
    stock: 35,
  },
];

const productData = catalog.map((product) => {
  const id = String(product.id).padStart(2, "0");
  const price = Math.min(180, Math.max(45, Number(product.price) || 45));
  const compareAtPrice = product.compareAtPrice
    ? Math.min(180, Math.max(price + 5, Number(product.compareAtPrice)))
    : null;

  return {
    ...product,
    price,
    compareAtPrice: compareAtPrice > price ? compareAtPrice : null,
    description: `${product.description} Thoughtful patterning supports comfortable movement, while durable materials make it a dependable choice for regular use. Practical storage and easy-care construction help it move smoothly between everyday routines, weekend walks and longer days outside.`,
    brand: siteConfig.brandName,
    image: `/img/product-${id}-main.jpg`,
    images: [
      `/img/product-${id}-main.jpg`,
      `/img/product-${id}-alt.jpg`,
    ],
    inStock: product.stock > 0,
  };
});

export default productData;
